var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#67d8cf;}.cls-2{fill:#edf9f9;}.cls-3{fill:#eef7f7;}.cls-4{fill:#80ded6;}.cls-5{fill:#9ee0dc;}.cls-6{fill:#8ae1d9;}.cls-7{fill:#8bd7d0;}.cls-8{fill:#baede8;}.cls-9{fill:#d3f2f0;}.cls-10{fill:#aceae4;}.cls-11{fill:#e1f7f6;}.cls-12{fill:#c7f1ed;}.cls-13{fill:#40c8bd;}.cls-14{fill:#5bd5cc;}.cls-15{fill:#73dbd3;}.cls-16{fill:#50d2c7;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 24.93,
    cy: 3.88,
    r: 3.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.8,
    cy: 5.36,
    r: 3.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 10.01,
    cy: 9.93,
    r: 3.32
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 5.43,
    cy: 16.88,
    r: 3.32
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 3.8,
    cy: 25,
    r: 3.32
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.05,
    cy: 5.36,
    r: 3.32
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 39.99,
    cy: 9.93,
    r: 3.32
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 44.57,
    cy: 16.88,
    r: 3.32
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 46.2,
    cy: 25,
    r: 3.32
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 44.57,
    cy: 33.12,
    r: 3.32
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 39.99,
    cy: 39.92,
    r: 3.32
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 33.2,
    cy: 44.5,
    r: 3.32
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 24.93,
    cy: 46.12,
    r: 3.32
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 16.8,
    cy: 44.5,
    r: 3.32
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.16,
    cy: 39.92,
    r: 3.32
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 5.28,
    cy: 33.12,
    r: 3.32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomSpinner);
export default __webpack_public_path__ + "static/media/Zoom-Spinner.e335a42286017a44fc20ff97213259a0.svg";
export { ForwardRef as ReactComponent };